import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar, Line, Doughnut } from 'react-chartjs-2'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
)

const TEAL = '#2dd4bf'
const TEXT = '#94a3b8'
const GRID = 'rgba(71, 85, 105, 0.4)'

function options(title: string, yLabel: string) {
  return {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: !!title, text: title, color: TEXT },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: !!yLabel, text: yLabel, color: TEXT },
        ticks: { color: TEXT },
        grid: { color: GRID },
      },
      x: {
        ticks: { color: TEXT, maxRotation: 0, autoSkip: true, maxTicksLimit: 8 },
        grid: { color: GRID },
      },
    },
  }
}

interface CommonProps {
  labels: string[]
  data: (number | null)[]
  title?: string
  yLabel?: string
  label?: string
}

export function BarChart({ labels, data, title = '', yLabel = '', label = '' }: CommonProps) {
  return (
    <Bar
      options={options(title, yLabel)}
      data={{
        labels,
        datasets: [{ label, data: data as number[], backgroundColor: TEAL, borderWidth: 1 }],
      }}
    />
  )
}

export function DoughnutChart({ segments }: { segments: { label: string; value: number; color: string }[] }) {
  return (
    <Doughnut
      options={{
        responsive: true,
        maintainAspectRatio: true,
        cutout: '68%',
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (c) => `${c.label}: ${Math.round(Number(c.parsed)).toLocaleString('en')} kcal`,
            },
          },
        },
      }}
      data={{
        labels: segments.map((s) => s.label),
        datasets: [
          {
            data: segments.map((s) => s.value),
            backgroundColor: segments.map((s) => s.color),
            borderWidth: 0,
          },
        ],
      }}
    />
  )
}

export function LineChart({ labels, data, title = '', yLabel = '', label = '' }: CommonProps) {
  return (
    <Line
      options={options(title, yLabel)}
      data={{
        labels,
        datasets: [
          {
            label,
            data: data as number[],
            borderColor: TEAL,
            backgroundColor: TEAL,
            borderWidth: 2,
            tension: 0.4,
            spanGaps: true,
          },
        ],
      }}
    />
  )
}
